import React from 'react';

const WorkMinimal = () => {
  const caseStudies = [
    {
      industry: 'Fashion Media',
      headline: 'Scaled Berlin Fashion Week digital presence through AI-optimised content strategy',
      description: 'Managed full digital marketing for The Garnette Report magazine during Berlin Fashion Week. Used AI audience segmentation and predictive scheduling to maximise reach across Instagram, email, and SEO — driving record traffic and engagement for the publication',
      image: '/images/marketing/fashion-media.jpg',
      imageAlt: 'Fashion media digital marketing — Berlin Fashion Week Instagram strategy'
    },
    {
      industry: 'E-commerce',
      headline: 'Tripled ROAS using AI-powered Meta ad creative testing',
      description: 'Rebuilt campaign structure for sustainable fashion brand with automated A/B testing across 40+ creative variations. AI insights identified winning patterns that reduced cost-per-purchase while scaling spend profitably',
      image: '/images/marketing/ecommerce-ads.jpg',
      imageAlt: 'E-commerce performance marketing — Meta ads dashboard with rising ROAS'
    },
    {
      industry: 'SaaS',
      headline: 'Cut cost-per-lead in half through AI audience modelling',
      description: 'Refined targeting for B2B software company using AI-driven lookalike analysis and behavioural segmentation. Shifted budget to highest-intent audiences, improving demo booking rate and sales pipeline quality',
      image: '/images/marketing/saas-ai.jpg',
      imageAlt: 'AI-powered B2B marketing analytics — audience segmentation and lead funnel'
    },
    {
      industry: 'Lifestyle Brand',
      headline: 'Doubled monthly revenue combining organic Instagram + paid funnel',
      description: 'Integrated AI content scheduling for organic reach with strategic Meta retargeting campaigns. Built trust through consistent touchpoints, converting followers into repeat customers with measurable lifetime value growth',
      image: '/images/marketing/instagram-growth.jpg',
      imageAlt: 'Instagram growth strategy — lifestyle brand follower and revenue growth'
    }
  ];

  return (
    <section id="work" className="bg-black">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        {/* Section Label */}
        <div className="mb-16">
          <span className="text-sm text-tertiary font-sans uppercase tracking-wider">Case Studies</span>
        </div>

        {/* Case Studies Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-20">
          {caseStudies.map((study, index) => (
            <div key={study.industry} className="space-y-4" data-testid={`case-study-${index}`}>
              {/* Case Study Image */}
              <div className="overflow-hidden rounded-lg border border-tertiary mb-6 group">
                <img
                  src={study.image}
                  alt={study.imageAlt}
                  loading="lazy"
                  className="w-full aspect-[3/2] object-cover transition-transform duration-700 group-hover:scale-105"
                  data-testid={`case-study-image-${index}`}
                />
              </div>

              {/* Industry Type */}
              <span className="text-sm text-tertiary font-sans">
                {study.industry}
              </span>

              {/* Headline Outcome */}
              <h3 className="font-serif-italic text-3xl lg:text-4xl text-gold leading-tight">
                {study.headline}
              </h3>

              {/* Description */}
              <p className="text-base text-secondary font-sans leading-relaxed">
                {study.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkMinimal;
